export const useActiveOrg = async () => {
  const {$propelAuth} = useNuxtApp();
  const {orgHelper} = await $propelAuth.getAuthenticationInfoOrNull();

  const getActiveOrg = () => {
    const defaultOrg = orgHelper.getOrgs()[0].orgId;
    const stored = localStorage.getItem('activeOrg');
    if (stored && !orgHelper.getOrgs().find(org => org.orgId === stored)) {
      localStorage.setItem('activeOrg', defaultOrg);
      return defaultOrg;
    }
    return stored || defaultOrg;
  };

  const setActiveOrg = async orgId => {
    const currentOrgId = getActiveOrg();
    if (currentOrgId === orgId) return;
    localStorage.setItem('activeOrg', orgId);
    await navigateTo('/');
    window.location.reload();
  };

  return {
    getActiveOrg,
    setActiveOrg,
  };
};
